import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/_side-layout/actions/your-actions/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/actions/your-actions/actions', search: {} });
  },
});
